
import React from 'react';
import footerBg from '../assets/FooterImg.jpg';
import logo from '../assets/Logo1.png'; // Update with the correct path
import { FaFacebookF, FaInstagram, FaYoutube, FaLinkedinIn, FaTwitter } from 'react-icons/fa';
import { IconContext } from 'react-icons';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer
      className="relative bg-cover bg-center bg-no-repeat text-white"
      style={{ backgroundImage: `url(${footerBg})` }}
    >
      {/* Overlay to darken the background */}
      <div className=" bg-opacity-70 p-8 sm:p-16">
        <div className="container mx-auto px-6 sm:px-8 lg:px-16 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10">

          {/* Logo and Social Media Section */}
          <div className="text-center md:text-left">
            <img
              src={logo}
              alt="MoveonWheels Logo"
              className="mx-auto md:mx-0 mb-6 w-32 h-auto"
            />
            <div className="flex justify-center md:justify-start space-x-4 mb-6">
              <IconContext.Provider value={{ size: '2rem', className: 'hover:opacity-75' }}>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                  <FaTwitter />
                </a>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                  <FaFacebookF />
                </a>
                <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
                  <FaYoutube />
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                  <FaInstagram />
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                  <FaLinkedinIn />
                </a>
              </IconContext.Provider>
            </div>

            {/* App Store Buttons */}
            <div className="flex space-x-2">
              <button className="bg-black/50 backdrop-blur-sm border border-white rounded px-4 py-2 text-sm hover:bg-black/70 transition-colors">
                App Store
              </button>
              <button className="bg-black/50 backdrop-blur-sm border border-white rounded px-4 py-2 text-sm hover:bg-black/70 transition-colors">
                Google Play
              </button>
            </div>
          </div>

          {/* Quick Links Section */}
          <div>
            <div className="flex justify-start">
              <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            </div>
            <ul className="space-y-2">
              <li className="hover:text-gray-400 cursor-pointer transition-colors flex items-center">
                <Link to="/product" className="hover:text-indigo-500"> &gt; Our Fleet </Link>
              </li>
              <li className="hover:text-gray-400 cursor-pointer transition-colors flex items-center">
                <Link to="/offers" className="hover:text-indigo-500"> &gt; Offers </Link>
              </li>
              <li className="hover:text-gray-400 cursor-pointer transition-colors flex items-center">
              <Link to="/franchise" className="hover:text-indigo-500"> &gt; Patner With Us </Link>
              </li>
              <li className="hover:text-gray-400 cursor-pointer transition-colors flex items-center">
              <Link to="/profile/wallet-amt" className="hover:text-indigo-500"> &gt; Wallet </Link>
              </li>
              <li className="hover:text-gray-400 cursor-pointer transition-colors flex items-center">
              <Link to="/membership-card" className="hover:text-indigo-500"> &gt; MemberShip </Link>
              </li>
            </ul>
          </div>

          {/* Company Section */}
          <div>
            <div className="flex justify-start">
              <h3 className="text-lg font-semibold mb-4">Company</h3>
            </div>
            <ul className="space-y-2">
              <li className="hover:text-gray-400 cursor-pointer transition-colors flex items-center">
              <Link to="/" className="hover:text-indigo-500"> &gt; Home </Link>
              </li>
              <li className="hover:text-gray-400 cursor-pointer transition-colors flex items-center">
              <Link to="/about" className="hover:text-indigo-500"> &gt; About </Link>
              </li>
              <li className="hover:text-gray-400 cursor-pointer transition-colors flex items-center">
              <Link to="/contact" className="hover:text-indigo-500"> &gt; Contact </Link>
              </li>
              <li className="hover:text-gray-400 cursor-pointer transition-colors flex items-center">
              <Link to="/blog" className="hover:text-indigo-500"> &gt; Blog </Link>
              </li>
              <li className="hover:text-gray-400 cursor-pointer transition-colors flex items-center">
              <Link to="/about" className="hover:text-indigo-500"> &gt; About </Link>
              </li>
            </ul>
          </div>

          {/* Contact Section */}
          <div>
            <div className="flex justify-start">
              <h3 className="text-lg font-semibold mb-4">CONTACT US</h3>
            </div>
            <div className="space-y-2">
              <p className="font-medium  flex items-center">Corporate Office</p>
              <p className="text-sm  flex items-center">
                YG447-778, <br />
                Basavanagar, <br />
                Kalishoi, Camp, <br />
                Belgavi, Karnataka <br />
                590019
              </p>
              <p className="text-sm  flex items-center">contact@moveonwheels.com</p>
            </div>
          </div>

        </div>
      </div>

      {/* Cityscape and Motorcycle Animation */}
      <div className="relative h-48 overflow-hidden">
        {/* Cityscape Background */}
        <div className="absolute bottom-0 w-full h-32 flex items-end">
          {[...Array(12)].map((_, i) => (
            <div
              key={i}
              className={`w-16 ${i % 3 === 0 ? 'h-32 bg-red-600/80' : 'h-24 bg-gray-300/80'} mx-1`}
              style={{ clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)' }}
            ></div>
          ))}
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-[#FF9630] text-center py-4 text-sm">
        <div className="container mx-auto px-4 flex flex-wrap justify-center items-center gap-2 md:space-x-4">
          <span className="hover:text-gray-200 cursor-pointer">Terms & Conditions</span>
          <span className="hidden md:inline">•</span>
          <span className="hover:text-gray-200 cursor-pointer">Privacy Policy</span>
          <span className="hidden md:inline">•</span>
          <span className="hover:text-gray-200 cursor-pointer">Refund Policy</span>
          <span className="hidden md:inline">•</span>
          <span className="hover:text-gray-200 cursor-pointer">Pricing Policy</span>
        </div>
        <div className="mt-2">© MoveonWheels 2024 - All rights reserved.</div>
      </div>
    </footer>
  );
};

export default Footer;
